import { Module } from 'vuex-smart-module';
import CompaniesUsersManagersActions from './actions';
import CompaniesUsersManagersGetters from './getters';
import CompaniesUsersManagersMutations from './mutations';
import CompaniesUsersManagersState from './state';

export default new Module({
  state: CompaniesUsersManagersState,
  mutations: CompaniesUsersManagersMutations,
  actions: CompaniesUsersManagersActions,
  getters: CompaniesUsersManagersGetters,
});
